import { render, staticRenderFns } from "./CosmoClawActivityOverlay.vue?vue&type=template&id=f6e75ed4&scoped=true"
import script from "./CosmoClawActivityOverlay.vue?vue&type=script&lang=js"
export * from "./CosmoClawActivityOverlay.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawActivityOverlay.vue?vue&type=style&index=0&id=f6e75ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e75ed4",
  null
  
)

export default component.exports